import React from 'react';
import PageChrome from '../components/layout/PageChrome';
import AlumniCard from '../components/cards/AlumniCard';
import alumniData from '../cms/alumni.json';
import '../css/pages/Alumni.css';

const alumniInfo = alumniData;
const alumniResources = alumniData.resources || [];

const Alumni = () => {
  const featuredResources = alumniResources.filter(resource => resource.featured);
  const otherResources = alumniResources.filter(resource => !resource.featured);

  return (
    <>
      <PageChrome
        title={alumniInfo.title}
        subtitle={alumniInfo.subtitle}
        intro={[alumniInfo.description, alumniInfo.welcomeMessage].filter(
          (item) => item != null && item !== ''
        )}
      >
        <section className="alumni-page-section">
          <div className="alumni-page-featured">
            <h2>Stay Connected</h2>
            <div className="alumni-page-grid">
              {featuredResources.map((resource) => (
                <AlumniCard key={resource.id} resource={resource} />
              ))}
            </div>
          </div>
          
          {otherResources.length > 0 && (
            <div className="alumni-page-other">
              <h2>Additional Opportunities</h2>
              <div className="alumni-page-grid">
                {otherResources.map((resource) => (
                  <AlumniCard key={resource.id} resource={resource} />
                ))}
              </div>
            </div>
          )}
        </section>
      </PageChrome>
    </>
  );
};

export default Alumni; 